/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RemoteService} from "../../services/driver-data-table-remote-service";
import {NgxSpinnerService} from 'ngx-spinner';
declare var $:any;

@Component({
    selector: 'driver-data-table',
    providers: [RemoteService],
    templateUrl: './driver-data-table.html',
    styleUrls: ['./driver-data-table.css'],
    standalone: false
})
export class DriverDataTable{
  items = [];

  itemCount = 0;

  constructor(private remoteService: RemoteService,
              private spinnerService: NgxSpinnerService,
              private cdr: ChangeDetectorRef) {  }

  @Input() searchFor: string;

  @Output() reloadItem = new EventEmitter();

  reloadItems(params, name? : string) {
   if (this.searchFor.length>0)
        name=this.searchFor;
      if (name == undefined || name.length == 0) {

      }
      else {
        this.doSearch(params, name);
      }
  }


  doSearch(params,name)
  {
    this.spinnerService.show();
    this.remoteService.queryByNames(name,params).subscribe(res => {
      this.items = res.body.content;
      this.itemCount = Number(res.body.totalElements);
        this.spinnerService.hide();
        this.cdr.detectChanges();
    },
      error =>{console.log("loading existing drivers API return error : " + error.toString()); this.spinnerService.hide();},
      () =>{this.spinnerService.hide();}
    );
  }

  rowClick(rowEvent) {
    window.location.href="#/driverDetail/"+ rowEvent.row.item.driverID;
  }

  rowTooltip(item) { return item.lastName + ', ' + item.firstName; }
}
